export default function reducer(state={
		brandPrices: {},
		fetching: false,
		adoptLoading: null,
		error: null
	}, action) {

	switch (action.type) {
		case "FETCH_BRAND_PRICES": {
			return {...state, fetching: true}
		}
		case "FETCH_BRAND_PRICES_FULFILLED": {
			return {...state, fetching: false, brandPrices: action.payload.data || {}}
		}
		case "FETCH_BRAND_PRICES_REJECTED": {
			return {...state, fetching: false, error: action.payload}
		}
		case "ADOPT_BRAND_PRICE": {
			return {...state, adoptLoading: action.payload}
		}
		case "ADOPT_BRAND_PRICE_FULFILLED": {
			return {...state, adoptLoading: null}
		}
		case "ADOPT_BRAND_PRICE_REJECTED": {
			return {...state, adoptLoading: null, error: action.payload}
		}
		default:
			return state;
	}
}
